export default {
  code404: '404',
  maintenanceMode: 'maintenance-mode'
}
